<template>
    <transition name="overlay-fade">
        <div v-if="overlay" class="overlay-frost">
            <div class="overlay-panel">
                <loading-spinner v-if="overlayLoading" :height="'56px'" :size="40" :width="3" no-margin-top />
                <template v-else>
                    <span class="overlay-panel__icon">
                        <v-icon size="34" color="error">mdi-wifi-alert</v-icon>
                    </span>
                    <div class="overlay-panel__title">{{ $t('common.reconnect_message') }}</div>
                    <v-btn
                        color="primary" depressed block :disabled="disabledBtn"
                        class="black--text text-none font-weight-bold overlay-panel__btn"
                        @click="reload">
                        {{ $t('common.try_again') }}
                    </v-btn>
                </template>
            </div>
        </div>
    </transition>
</template>

<script>

import {mapMutations, mapState} from 'vuex'
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    components: {LoadingSpinner},
    data() {
        return {
            disabledBtn: false,
        }
    },
    computed: {
        ...mapState(['overlay', 'overlayLoading']),
    },
    mounted() {
        const vm = this
        window.addEventListener('online', vm.updateOnlineStatus);
        window.addEventListener('offline', vm.updateOnlineStatus);
    },
    beforeDestroy() {
        window.removeEventListener('online', this.updateOnlineStatus);
        window.removeEventListener('offline', this.updateOnlineStatus);
    },
    methods: {
        ...mapMutations(['showOverlay', 'hideOverlay']),
        updateOnlineStatus() {
            const vm = this
            if (navigator.onLine) {
                vm.disabledBtn = false
                vm.hideOverlay()
            } else {
                vm.disabledBtn = true
                vm.showOverlay()
            }
        },
        reload() {
            const vm = this
            vm.$router.go(0)
        }
    }
}
</script>

<style scoped>
.overlay-frost {
    position: fixed;
    inset: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(6, 8, 12, 0.62);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
}

.overlay-fade-enter-active,
.overlay-fade-leave-active {
    transition: opacity 0.2s ease;
}

.overlay-fade-enter,
.overlay-fade-leave-to {
    opacity: 0;
}

.overlay-panel {
    width: 320px;
    max-width: calc(100vw - 48px);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 32px 28px;
    border-radius: 16px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    box-shadow: 0 20px 48px rgba(0, 0, 0, 0.45);
}

.overlay-panel__icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(232, 92, 92, 0.12);
    border: 1px solid rgba(232, 92, 92, 0.32);
}

.overlay-panel__title {
    margin-top: 20px;
    font-size: var(--fs-body);
    font-weight: 500;
    line-height: 1.4;
    color: var(--v-txtPrimary-base);
}

.overlay-panel__btn {
    margin-top: 24px;
}
</style>
